var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanetFnvu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_785_819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274 137C274 150.006 272.266 163.013 268.508 174.863C261.572 199.141 248.276 220.529 230.067 237.293C217.35 249.143 202.032 258.681 185.268 265.04C170.238 270.821 153.764 274 136.711 274C134.399 274 131.798 274 129.485 273.711C126.017 273.422 122.259 273.133 118.791 272.844C92.4894 269.376 68.2109 258.392 48.846 241.918C41.6202 235.848 34.9726 228.911 28.9029 221.397C24.5675 215.616 20.5211 209.835 16.7638 203.477C15.8967 202.032 15.0295 200.586 14.4515 198.852C13.5844 197.118 12.7173 195.673 12.1393 193.939C9.82704 188.736 7.80381 183.245 6.06964 177.753C4.91352 173.707 3.75738 169.66 2.89029 165.614C2.31224 162.724 1.73418 159.833 1.44515 156.654C0.578059 150.295 0 143.937 0 137.289C0 133.532 3.52733e-05 129.774 0.578094 126.017C0.867124 123.705 1.15612 121.392 1.44515 119.08C3.17932 105.496 6.93676 92.7784 12.4283 80.9282C15.0296 75.1476 18.2089 69.3669 21.6772 63.8754C27.4578 54.9155 34.1055 46.5336 41.9093 39.3078C66.4768 15.3184 100.293 0.577881 137.289 0.577881C138.734 0.577881 140.179 0.577881 141.624 0.577881C143.07 0.577881 144.804 0.577898 146.249 0.866928C154.053 1.44499 161.857 2.6011 169.082 4.33528C173.418 5.49139 177.753 6.64752 181.8 8.09267C184.69 8.95976 187.291 10.1159 190.181 11.272C192.205 12.1391 194.228 13.0062 196.251 13.8733C196.54 14.1623 196.829 14.1623 197.407 14.4514C210.703 20.81 222.842 29.4809 233.247 39.8859C234.692 41.3311 236.137 42.7763 237.582 44.5104C238.449 45.6666 239.605 46.5337 240.472 47.6898C241.918 49.424 243.652 51.4471 245.097 53.1813C250.589 60.118 255.213 67.6328 259.259 75.4366C263.884 84.6855 267.641 94.5125 270.243 104.629C272.555 114.456 274 125.728 274 137Z",
    fill: "url(#paint0_radial_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.829 12.4283C196.251 12.4283 195.962 12.4283 195.384 12.7173C193.939 13.0064 192.494 12.7173 191.049 12.4283C189.892 12.1393 189.314 11.5612 187.869 11.5612C186.135 11.2722 184.69 10.6941 182.956 10.405C181.222 10.116 179.776 9.53795 178.042 8.95989C176.597 8.38183 176.019 8.67086 174.863 8.95989C173.707 9.24892 172.84 8.67092 171.683 8.38189C170.527 7.80383 169.082 7.80382 167.926 7.51479C164.458 6.93673 160.989 5.78059 157.521 4.9135C155.498 4.33544 153.475 4.33545 151.162 4.33545C149.428 4.33545 147.983 4.9135 146.249 4.9135C145.093 4.9135 144.226 4.62449 143.07 4.62449C141.913 4.33546 140.757 4.62449 139.601 4.62449C137.867 4.33546 137 4.04643 135.266 4.62449C133.821 4.91352 132.954 4.91351 131.508 5.20254C130.063 5.20254 128.329 5.78061 126.884 6.06964C124.283 6.6477 121.392 7.22574 118.791 7.22574C117.057 7.22574 114.745 6.64768 113.3 7.22574C112.433 7.51477 111.854 8.67088 110.987 9.24894C109.542 10.6941 108.097 11.8502 106.941 13.2953C105.785 14.7405 104.629 16.4747 104.629 18.4979C104.629 20.2321 105.496 22.2553 106.363 23.7004C107.23 25.4346 107.519 26.8798 105.785 28.0359C103.762 29.481 101.16 30.6372 98.8481 31.5043C97.1139 32.0823 95.6688 32.3713 94.5127 31.2152C93.9346 30.9262 93.6456 30.0591 93.0675 29.481C92.4895 29.192 91.6223 29.481 91.0443 29.7701C89.3101 30.3481 87.576 30.9262 85.8418 31.2152C84.6857 31.5042 83.8186 32.0823 82.6624 32.0823C81.5063 32.3713 80.6392 31.5043 79.1941 31.7933C77.4599 32.0823 75.4367 32.9494 73.7025 32.9494C72.2574 32.9494 70.5232 32.3714 69.3671 31.7933C68.789 31.5043 68.5 30.9262 67.6329 31.2152C67.0548 31.2152 66.1878 32.0823 65.8988 32.6604C65.3207 33.2384 65.3206 34.1055 64.7426 34.6836C64.1645 35.5507 63.8755 36.1287 63.2974 36.9958C62.4304 38.441 61.5633 39.8861 60.6962 41.3313C60.1181 42.1983 59.5401 43.6435 58.673 44.5106C58.384 45.0887 57.5169 45.3777 56.9388 45.6667C55.4937 46.5338 54.0485 47.6899 52.6034 48.557C50.0021 50.5802 47.4008 52.8925 44.7996 54.9157C42.7764 56.3608 39.8861 57.2279 37.5738 58.384C36.1287 58.962 34.6835 59.5401 33.2384 60.1182C32.6603 60.4072 31.7932 60.4072 31.5042 60.9852C30.9261 61.5633 30.6371 62.1414 30.3481 63.0085C29.192 64.4536 27.7469 66.1878 26.8798 67.922C26.3017 69.0781 26.0127 69.9452 25.4346 71.1013C24.8566 72.5464 23.9895 73.9916 23.7005 75.7258C22.5443 78.9051 22.5444 82.3734 21.0992 85.5528C20.5211 87.2869 19.365 89.0212 18.4979 90.7553C17.0527 93.6456 16.7637 97.114 16.4747 100.293C16.1857 102.027 16.4747 104.34 16.7638 106.074C17.0528 108.097 17.0527 110.12 17.0527 112.144C17.0527 114.167 15.6076 116.479 14.4515 117.924C13.2954 119.369 11.2721 119.947 9.82698 121.393C8.67087 122.549 7.22579 123.705 6.64773 125.439C6.3587 126.017 6.64773 126.884 6.64773 127.751C6.3587 129.485 5.78059 130.93 5.78059 132.665C5.49156 134.688 5.49154 136.711 5.49154 139.023C5.49154 140.179 5.49154 141.046 5.49154 142.203C5.49154 143.359 5.78061 144.226 6.06964 145.093C6.06964 145.671 6.06964 146.538 6.06964 147.116C6.06964 147.983 6.64773 148.85 6.64773 149.428C7.22579 151.452 7.5148 153.186 7.80383 155.209C8.09286 156.943 8.95995 158.677 9.24898 160.412C10.1161 162.724 10.4051 165.036 10.9832 167.637C11.2722 169.371 11.2722 171.395 11.5612 173.129C11.8502 174.574 12.1393 176.019 12.1393 177.464C12.1393 179.776 11.5612 181.8 11.5612 184.112C11.5612 187.869 13.0064 191.627 13.8735 195.384C14.1625 196.54 14.4515 197.407 14.7405 198.563C5.20255 180.065 0 158.966 0 136.711C0 109.542 7.80378 84.3967 21.3882 63.2975C27.1688 54.3376 33.8164 45.9557 41.6202 38.73C66.1877 14.7405 100.004 0 137 0C139.89 0 143.07 1.76367e-05 145.96 0.289047C164.169 1.76367e-05 181.221 4.91351 196.829 12.4283Z",
    fill: "url(#paint1_linear_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.654 3.46835C106.654 3.46835 118.216 127.751 121.684 138.156C125.152 148.85 156.078 168.215 168.796 170.528C181.513 172.84 213.595 184.69 221.977 184.112C230.359 183.823 266.777 180.644 266.777 180.644L271.69 160.99C271.69 160.99 203.768 108.386 179.779 60.4072C155.789 12.4283 156.367 1.15615 156.367 1.15615L145.962 0C145.962 0 171.975 50.2912 179.779 74.5697C187.293 99.1372 219.665 123.127 234.116 137.289C248.568 151.452 244.232 176.019 226.891 174.863C209.26 173.707 149.431 177.175 134.69 131.798C128.332 112.143 122.551 93.0676 118.215 60.1182C113.302 28.0359 106.654 3.46835 106.654 3.46835Z",
    fill: "url(#paint2_radial_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4906 98.5595C5.4906 98.5595 52.3134 116.479 70.2333 128.619C88.1531 140.758 136.421 154.631 146.537 165.325C156.653 176.019 173.995 195.674 172.55 205.212C171.104 214.46 110.408 207.813 86.1299 198.853C61.8514 189.893 21.3872 171.395 15.8957 162.435C10.4041 153.764 0.577148 148.273 0.577148 148.273L2.0223 160.701C2.0223 160.701 62.4294 200.587 70.5222 203.766C78.615 206.946 161.278 222.553 184.4 218.218C184.4 218.218 195.383 208.969 155.208 169.083C139.022 153.186 110.119 140.18 83.2396 128.041C43.3535 109.832 6.35774 95.6692 6.35774 95.6692L5.4906 98.5595Z",
    fill: "url(#paint3_radial_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.686 4.62417C171.686 4.62417 174.865 40.1748 186.426 69.3668C197.987 98.5588 220.532 103.472 230.07 114.455C239.897 125.149 265.331 139.601 273.713 133.82L273.135 156.365C273.135 156.365 181.513 119.947 156.078 1.44482L171.686 4.62417Z",
    fill: "url(#paint4_radial_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1719 218.795C27.1719 218.795 66.191 208.101 113.592 215.327C175.155 224.576 188.161 229.2 193.653 235.848C199.145 242.496 201.168 258.103 201.168 258.103L207.815 254.346C207.815 254.346 204.347 223.998 197.121 219.084C189.895 214.171 131.801 224.287 70.8154 203.766L19.6572 207.523L27.1719 218.795Z",
    fill: "url(#paint5_radial_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.258 181.8C206.657 174.863 168.505 165.325 162.146 170.528C156.944 174.863 191.049 214.171 199.431 215.328C207.813 216.484 211.859 188.737 209.258 181.8ZM195.385 203.477C185.558 201.743 163.013 178.621 167.927 173.996C171.973 170.239 202.61 180.066 204.923 185.847C206.946 191.627 205.212 205.501 195.385 203.477Z",
    fill: "url(#paint6_radial_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8822 260.416C76.8822 260.416 82.3737 218.506 86.4202 218.506C89.5995 218.506 95.0911 224.865 106.074 233.247C109.254 235.559 112.722 238.16 116.768 240.762C120.237 243.074 124.572 245.386 129.486 247.698C137.578 251.456 147.116 255.502 155.498 258.682C169.083 263.884 180.066 267.352 180.066 267.352L182.089 265.907C182.089 265.907 172.551 263.884 159.834 259.549C159.834 259.549 173.129 237.871 190.182 218.217C207.235 198.563 272.844 152.319 272.844 152.319L273.422 145.671C273.422 145.671 254.635 161.279 233.825 177.753C233.825 177.753 247.699 82.3734 252.034 67.0549L247.699 65.3207C247.699 65.3207 237.294 159.255 226.021 184.112C206.367 199.719 186.424 214.46 180.933 216.194C168.505 220.241 122.838 183.534 122.549 183.534C121.393 145.671 122.26 103.473 125.439 92.4895C171.973 48.268 216.773 26.3017 216.773 26.3017L214.749 24.2785C214.749 24.2785 170.239 55.4937 168.794 49.7131C167.348 43.6435 196.829 13.5844 196.829 13.5844L193.361 13.0064C193.361 13.0064 160.701 54.9156 115.612 99.1372C83.8189 130.352 73.1248 139.89 69.6565 142.781C63.8759 110.12 63.5869 75.7258 73.1249 53.4705C91.0447 11.8503 116.19 2.31226 116.19 2.31226C112.144 2.31226 103.473 4.33545 103.473 4.33545C103.473 4.33545 91.0447 19.0759 85.5531 27.7468C80.3506 36.4177 73.1249 53.1815 68.7894 50.5802C64.454 47.979 51.4476 29.7701 51.4476 29.7701L50.0025 31.2152C50.0025 31.2152 62.4307 43.0655 64.7429 52.0254C67.0552 60.9853 65.032 117.057 59.2514 114.745C53.4708 112.722 13.0067 78.0381 13.0067 78.0381L11.5615 80.9283C11.5615 80.9283 54.0489 109.831 59.2514 120.236C61.8527 125.15 68.2113 143.937 73.7029 162.435C73.1248 159.833 71.1016 150.584 71.9687 146.827C86.1311 125.728 102.317 115.034 118.213 99.1372C121.682 118.791 121.682 187.869 121.393 221.975L105.496 229.779C100.872 225.443 96.8252 220.819 93.6459 215.616C89.0214 207.812 84.397 197.407 80.3506 185.846C82.6628 194.806 84.397 201.454 84.397 203.477C84.397 210.414 73.9919 259.549 73.9919 259.549L76.8822 260.416ZM233.825 178.042C231.513 180.065 228.912 181.8 226.599 183.823L233.825 178.042ZM122.838 184.979V187.869C122.838 186.713 122.838 185.846 122.838 184.979ZM122.838 187.869C122.838 187.869 166.77 215.038 173.996 220.241C180.644 224.865 159.256 253.768 156.076 258.103C147.694 254.924 138.156 251.167 128.908 245.964C126.017 237.871 123.994 214.46 122.838 187.869ZM121.682 224.576C121.682 234.981 121.393 241.629 121.393 241.629C116.768 238.738 112.144 235.27 108.097 231.802C110.988 229.2 116.768 225.154 121.682 224.576Z",
    fill: "url(#paint7_linear_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0654 174.574C36.7067 165.325 0 132.376 0 132.376V141.047C0 141.047 33.2384 160.701 42.1983 176.887C51.1582 193.072 41.6202 235.849 41.6202 235.849L45.0886 239.317C45.3776 239.317 52.3143 188.159 43.0654 174.574Z",
    fill: "url(#paint8_linear_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.607 2.312C152.607 2.312 162.145 43.0652 199.43 93.6454C236.715 144.226 271.688 161.278 271.688 161.278L273.133 152.318C273.133 152.318 241.05 147.116 203.477 97.1137C159.544 38.7297 159.833 2.02295 159.833 2.02295L152.607 2.312Z",
    fill: "url(#paint9_linear_785_819)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.436 140.18C122.546 129.775 106.649 3.46851 106.649 3.46851L103.759 4.0466C103.759 4.0466 128.615 127.751 107.805 131.22C91.3306 134.11 7.22299 92.7786 7.22299 92.7786L5.19983 98.8483C5.19983 98.8483 109.828 131.509 148.847 165.614C162.143 177.175 173.415 190.471 182.664 203.477C186.999 209.547 182.664 217.639 175.438 217.929C67.9191 218.796 1.73145 160.99 1.73145 160.99L2.5985 165.614C2.5985 165.614 68.2083 200.298 61.5606 204.055C54.9129 207.812 16.761 204.055 16.761 204.055L19.0732 208.102C19.0732 208.102 49.7103 205.5 89.3073 210.992C122.835 215.616 179.196 222.553 195.959 224.576C204.63 240.184 208.966 252.034 207.52 254.635L214.168 250.589C203.474 220.53 205.786 186.713 221.683 184.69C237.579 182.956 263.881 188.447 263.881 188.447L266.482 181.222C178.906 184.979 128.615 150.585 125.436 140.18ZM121.39 144.226C118.788 144.226 108.961 137 110.117 135.844C111.274 134.688 117.343 121.104 119.366 122.838C121.39 124.861 123.702 143.937 121.39 144.226ZM65.607 203.477C65.607 203.477 66.185 201.454 67.0521 201.165C67.9192 200.876 85.8391 206.945 84.6829 207.812C83.8158 208.68 65.607 205.789 65.607 203.477ZM201.74 211.281C195.092 210.703 155.495 173.707 162.143 170.528C167.056 168.215 202.896 176.597 206.075 183.534C208.966 190.471 208.099 211.859 201.74 211.281Z",
    fill: "url(#paint10_linear_785_819)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_785_819",
    x: 0,
    y: 0,
    width: 282,
    height: 282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_785_819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_785_819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_785_819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1233 72.9526) rotate(18.4597) scale(246.594 246.594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142857,
    stopColor: "#FFB1AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285714,
    stopColor: "#FF9F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428571,
    stopColor: "#FAA9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571429,
    stopColor: "#E893A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714286,
    stopColor: "#D77A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857143,
    stopColor: "#CB7BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5C93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_785_819",
    x1: -0.00520253,
    y1: 97.988,
    x2: 196.968,
    y2: 97.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#F3E1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FFC1B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFE6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FFF1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#FFD08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEACA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_785_819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.634 138.977) scale(99.0854 99.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C7FB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_785_819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.94 195.46) scale(101.196 101.197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF92F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_785_819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221 118.143) scale(74.3762 74.3763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DABDDC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_785_819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.221 244.625) scale(97.8064 97.8064)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A5C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_785_819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.377 206.593) scale(29.3006 29.3007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_785_819",
    x1: 227.868,
    y1: 37.0764,
    x2: 40.1767,
    y2: 224.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#FFCE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2899,
    stopColor: "#EEFF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    stopColor: "#E4FFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6749,
    stopColor: "#FFC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8407,
    stopColor: "#FB8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    stopColor: "#FF4E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_785_819",
    x1: -3.03273e-7,
    y1: 143.014,
    x2: 7.37116,
    y2: 201.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#FFB084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FFBC7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FFA470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864155,
    stopColor: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_785_819",
    x1: 152.511,
    y1: 81.6148,
    x2: 273.138,
    y2: 81.6148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FFC9BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FFBAC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDABD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EF8BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CF79DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#BD6FE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_785_819",
    x1: 2.01441,
    y1: 128.738,
    x2: 266.679,
    y2: 128.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FFD1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FECCB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FEC9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FAC4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EFB9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DE91DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#D58FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF9DFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetFnvu);
export default __webpack_public_path__ + "static/media/PlanetFNVU.8a26ba519d649067841d789f3cc6849f.svg";
export { ForwardRef as ReactComponent };